/**
 * 应用路由配置
 * 定义所有页面的路径、标签、图标和组件映射
 */
import { lazy } from 'react';
import { Gauge, Sliders, Disc3, Wrench, Microscope, AlertTriangle } from 'lucide-react';

/** 路由配置接口 */
export interface AppRoute {
  path: string;
  label: string;
  icon: React.ReactNode;
  element: React.ReactNode;
  hidden?: boolean;
}

const DashboardPage = lazy(() =>
  import('@/pages/dashboard/page').then((module) => ({ default: module.DashboardPage }))
);
const PidTunerPage = lazy(() =>
  import('@/pages/pid-tuner/page').then((module) => ({ default: module.PidTunerPage }))
);
const RecorderPage = lazy(() =>
  import('@/pages/recorder/page').then((module) => ({ default: module.RecorderPage }))
);
const AutoTunePage = lazy(() =>
  import('@/pages/auto-tune/page').then((module) => ({ default: module.AutoTunePage }))
);
const IdentificationPage = lazy(() =>
  import('@/pages/identification/page').then((module) => ({ default: module.IdentificationPage }))
);
const FaultPage = lazy(() =>
  import('@/pages/fault/page').then((module) => ({ default: module.FaultPage }))
);

/** 应用路由列表（仪表盘、PID调谐、数据录制、自动整定、参数辨识、故障诊断） */
export const appRoutes: AppRoute[] = [
  {
    path: '/',
    label: '仪表盘',
    icon: <Gauge className="w-5 h-5" />,
    element: <DashboardPage />,
  },
  {
    path: '/pid-tuner',
    label: 'PID调谐',
    icon: <Sliders className="w-5 h-5" />,
    element: <PidTunerPage />,
  },
  {
    path: '/recorder',
    label: '数据录制',
    icon: <Disc3 className="w-5 h-5" />,
    element: <RecorderPage />,
  },
  {
    path: '/auto-tune',
    label: '自动整定',
    icon: <Wrench className="w-5 h-5" />,
    element: <AutoTunePage />,
  },
  {
    path: '/identification',
    label: '参数辨识',
    icon: <Microscope className="w-5 h-5" />,
    element: <IdentificationPage />,
  },
  {
    path: '/faults',
    label: '故障诊断',
    icon: <AlertTriangle className="w-5 h-5" />,
    element: <FaultPage />,
  },
];
